"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var defaultStore = {
    findText: '',
};
exports.default = satcheljs_1.createStore('findFavorites', defaultStore)();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-find-favorites-store/lib/store/store.js
// module id = 3946
// module chunks = 68